/**
 * VixoKart Theme — Phase 9: Utility Pages JavaScript
 * Handles: FAQ search + category filter, 404 search, policy nav spy,
 *          skeleton removal, contact form feedback.
 *
 * Rules:
 *  - No global variables. No overrides to existing theme.js functions.
 *  - Null-checks before every DOM access.
 *  - Wrapped in IIFE.
 */

'use strict';

(function VKUtility() {

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }
  function on(el, evt, fn) { if (el) el.addEventListener(evt, fn); }

  /* ─── 1. FAQ page: search + category filter ─────────────────────────────── */

  function initFaqPage() {
    var searchInput = $('#vk-faq-search');
    var tabs        = $$('.vk-faq-tab');
    var items       = $$('.vk-faq-item-wrap');
    var noResults   = $('#vk-faq-no-results');

    if (!items.length) return;

    var activeCategory = 'all';

    function getQuery() {
      return searchInput ? searchInput.value.trim().toLowerCase() : '';
    }

    function applyFilter() {
      var query  = getQuery();
      var count  = 0;

      items.forEach(function(wrap) {
        var cat       = (wrap.getAttribute('data-category') || '').toLowerCase();
        var text      = (wrap.textContent || '').toLowerCase();
        var catMatch  = activeCategory === 'all' || cat === activeCategory;
        var txtMatch  = !query || text.includes(query);

        var show = catMatch && txtMatch;
        wrap.style.display = show ? '' : 'none';
        if (show) count++;
      });

      if (noResults) {
        noResults.classList.toggle('is-visible', count === 0);
      }
    }

    // Category tab clicks
    tabs.forEach(function(tab) {
      on(tab, 'click', function() {
        tabs.forEach(function(t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');
        activeCategory = (tab.getAttribute('data-category') || 'all').toLowerCase();
        applyFilter();
      });
    });

    // Search input
    var debounceTimer;
    on(searchInput, 'input', function() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(applyFilter, 200);
    });

    // Clear search on Escape
    on(searchInput, 'keydown', function(e) {
      if (e.key === 'Escape') {
        searchInput.value = '';
        applyFilter();
      }
    });
  }

  /* ─── 2. Policy page: section spy ───────────────────────────────────────── */

  function initPolicySpy() {
    var navLinks = $$('.vk-policy-nav__link[href^="#"]');
    if (!navLinks.length) return;

    var headings = navLinks.map(function(link) {
      return document.getElementById(link.getAttribute('href').slice(1));
    }).filter(Boolean);

    if (!headings.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var id = entry.target.id;
        navLinks.forEach(function(link) {
          link.classList.toggle('is-active', link.getAttribute('href') === '#' + id);
        });
      });
    }, { rootMargin: '-20% 0px -70% 0px' });

    headings.forEach(function(h) { observer.observe(h); });
  }

  /* ─── 3. 404 search form ─────────────────────────────────────────────────── */

  function init404Search() {
    var input = $('#vk-404-search-input');
    var btn   = $('#vk-404-search-btn');
    var form  = $('#vk-404-search-form');
    if (!input || !form) return;

    // Submit on button click or Enter (form handles naturally, but ensure non-empty)
    on(form, 'submit', function(e) {
      var q = input.value.trim();
      if (!q) { e.preventDefault(); input.focus(); }
    });
  }

  /* ─── 4. Contact form: character counter for message ──────────────────────── */

  function initContactForm() {
    var textarea = $('#vk-contact-message');
    var counter  = $('#vk-msg-counter');
    if (!textarea || !counter) return;

    var max = parseInt(textarea.getAttribute('maxlength') || '1000', 10);

    function update() {
      var remaining = max - textarea.value.length;
      counter.textContent = remaining + ' characters remaining';
      counter.style.color = remaining < 50 ? 'var(--color-warning)' : 'var(--color-text-muted)';
    }

    on(textarea, 'input', update);
    update();
  }

  /* ─── 5. Remove skeleton placeholders once section loads ─────────────────── */

  function initSkeletons() {
    // Skeletons are replaced when their nearest data-src images load
    $$('[data-vk-skeleton-parent]').forEach(function(parent) {
      var img = parent.querySelector('img');
      if (!img) { parent.removeAttribute('data-vk-skeleton-parent'); return; }

      if (img.complete) {
        parent.removeAttribute('data-vk-skeleton-parent');
        return;
      }

      img.addEventListener('load', function() {
        parent.removeAttribute('data-vk-skeleton-parent');
      });
    });
  }

  /* ─── Init ─────────────────────────────────────────────────────────────── */

  function init() {
    initFaqPage();
    initPolicySpy();
    init404Search();
    initContactForm();
    initSkeletons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
